import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InvoiceCashReceiptRetentionModel } from 'src/app/models/wallet/invoice-cash-receipt-retention.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceCashReceiptRetentionService {

  constructor(private _httpClient: HttpClient) { }

  createInvoiceCashReceiptRetention(invoiceCashReceiptRetentionContract: InvoiceCashReceiptRetentionModel): Observable<InvoiceCashReceiptRetentionModel> {
    return this._httpClient.post<InvoiceCashReceiptRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.CreateInvoiceCashReceiptRetention}`,
      invoiceCashReceiptRetentionContract);
  }

  deleteInvoiceCashReceiptRetention(invoiceCashReceiptRetentionId: number): Observable<InvoiceCashReceiptRetentionModel> {
    return this._httpClient.delete<InvoiceCashReceiptRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.DeleteInvoiceCashReceiptRetention}/${invoiceCashReceiptRetentionId}`);
  }

  getAllRetentionsModalWithPaginationAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, invoiceCashReceiptId: number): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '')
      .set('ascendant', ascendant).set('invoiceCashReceiptId', invoiceCashReceiptId);

    return this._httpClient.get<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.GetAllRetentionsModalWithPaginationAsync}`,
      { params: params }
    );
  }

  getColumnsForModalConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.GetColumnsForModalConsultationAsync}`);
  }

  getInvoiceCashReceiptRetentionById(invoiceCashReceiptRetentionId: number): Observable<InvoiceCashReceiptRetentionModel> {
    return this._httpClient.get<InvoiceCashReceiptRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.GetInvoiceCashReceiptRetentionById}/${invoiceCashReceiptRetentionId}`);
  }

  GetInvoiceCashReceiptRetentionByKeys(invoiceCashReceiptId: number, taxId: number): Observable<InvoiceCashReceiptRetentionModel> {
    return this._httpClient.get<InvoiceCashReceiptRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.GetInvoiceCashReceiptRetentionByKeys}/${invoiceCashReceiptId}/${taxId}`);
  }

  updateInvoiceCashReceiptRetention(invoiceCashReceiptRetentionContract: InvoiceCashReceiptRetentionModel): Observable<InvoiceCashReceiptRetentionModel> {
    return this._httpClient.put<InvoiceCashReceiptRetentionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.invoiceCashReceiptRetention.UpdateInvoiceCashReceiptRetention}`,
      invoiceCashReceiptRetentionContract);
  }
}
